<template>
	<div class="Item">
		<headerItemDv1 msg="银行月授信金额"></headerItemDv1>
		<div class="grid-container">
            <div id="chart" ref="chart" style="width: 100%; min-height: 550px;" class="flex-1 charts-style"></div>
        </div>
	</div>
</template>
<script>
import headerItemDv1 from '../components/headerItemDv1.vue';
import * as echarts from 'echarts';

export default {
	name: '',
	components: {
		headerItemDv1
	},
    props: {
        current: Number,
    },
    watch: {
        current(newVal, oldVal) {
            if (newVal === 1) {
                this.data = this.data1
            } else if (newVal === 0) {
                this.data = this.data0
            }
            this.initChart(this.data);
        }
    },
	data() {
		return {
            data: [],
            data0: [{
                "name": "一月",
                "value": 680
            }, {
                "name": "二月",
                "value": 48745
            }, {
                "name": "三月",
                "value": 27098
            }],
            data1: [{
                "name": "一月",
                "value": 810513
            }, {
                "name": "二月",
                "value": 313185
            }, {
                "name": "三月",
                "value": 574105
            }]
		}
	},
    created() {
        this.data = this.data0
    },
	mounted() {
        this.initChart(this.data);
	},
	methods: {
        initChart(list) {
            const myChart = echarts.init(this.$refs.chart);
            var data = list;
            var xData = [],
                yData = [];
            var min = 50;
            data.map(function (a, b) {
                xData.push(a.name);
                if (a.value === 0) {
                    yData.push(a.value + min);
                } else {
                    yData.push(a.value);
                }
            });
            const option = {
                // backgroundColor: "#111c4e",
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            opacity: 0
                        }
                    },
                    formatter: function (prams) {
                        if (prams[0].data === min) {
                            return "合格率：0%"
                        } else {
                            return prams[0].data + "万元"
                        }
                    }
                },
                legend: {
                    data: ['直接访问', '背景'],
                    show: false
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    bottom: '5%',
                    top: '7%',
                    height: '85%',
                    containLabel: true,
                    z: 22
                },
                xAxis: [{
                    type: 'category',
                    gridIndex: 0,
                    data: xData,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#0c3b71'
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: 'rgb(170,170,170)',
                        fontSize: 16
                    }
                }],
                yAxis: [{
                    type: 'value',
                    gridIndex: 0,
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    // min: min,
                    // max: 100,
                    axisLine: {
                        lineStyle: {
                            color: '#0c3b71'
                        }
                    },
                    axisLabel: {
                        color: 'rgb(170,170,170)',
                        // formatter: '{value}'
                    }
                },
                {
                    type: 'value',
                    gridIndex: 0,
                    min: min,
                    max: 100,
                    splitNumber: 12,
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: ['rgba(250,250,250,0.0)', 'rgba(250,250,250,0.05)']
                        }
                    }
                }
                ],
                series: [{
                    name: '合格率',
                    type: 'bar',
                    barWidth: '30%',
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    itemStyle: {
                        normal: {
                            barBorderRadius: 30,
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#00feff'
                                },
                                {
                                    offset: 0.5,
                                    color: '#027eff'
                                },
                                {
                                    offset: 1,
                                    color: '#0286ff'
                                }
                            ]
                            )
                        }
                    },
                    data: yData,
                    zlevel: 11

                },
                {
                    name: '背景',
                    type: 'bar',
                    barWidth: '50%',
                    xAxisIndex: 0,
                    yAxisIndex: 1,
                    barGap: '-135%',
                    data: [100, 100, 100, 100, 100, 100, 100],
                    itemStyle: {
                        normal: {
                            color: 'rgba(255,255,255,0.1)'
                        }
                    },
                    zlevel: 9
                },

                ]
            };
            myChart.setOption(option);
            window.onresize = function () {
                myChart.resize();
            }
        }
	}
}
</script>
<style lang="less" scoped>
.Item {
    font-size: 10px !important;
	.grid-container {
        width: 90%;
        margin: 10px auto 0;
        // display: grid;
        // grid-template-columns: repeat(2, 1fr);
        // grid-gap: 10px;
        // justify-items: center;
        .grid-item {
            box-sizing: border-box;
            border: 1px solid rgba(22, 33, 55, 1);
            text-align: center;
            padding: 14px;
            border-radius: 2px;
        }
    }
}

</style>
